import useLocalize from '../../../utils/hooks/useLocalize';
import SectionHeaderComponent from '../SectionHeaderComponent';
import './SummarySection.scss';

const PreviousPriceSection = () => {
  const localize = useLocalize();
  const title = localize('symbol.details.previous.price.section.title');
  return (
    <div className="summary-section">
      <SectionHeaderComponent title={title} />
      <div className="summary-section-content">
        {/* Previous price content will be added in future stories */}
      </div>
    </div>
  );
};

export default PreviousPriceSection;
